import React from 'react'
import classnames from 'classnames'
import Button from '../../../components/Button'

const Gutter = props => {
  const { mealCount, toggleSelectedMeals, className } = props

  return (
    !!mealCount && (
      <div
        className={classnames('cookunity__menu__gutter_container', className)}>
        <span>
          <strong>
            {mealCount} {mealCount > 1 ? 'items' : 'item'}
          </strong>{' '}
          in your cart
        </span>

        <Button large dark onClick={toggleSelectedMeals}>
          View Cart
        </Button>
      </div>
    )
  )
}

export default Gutter



// WEBPACK FOOTER //
// ./src/modules/Menu/Gutter/Gutter.jsx